import 'element-closest';
import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';

import App from './containers/App';

import { unregister } from './registerServiceWorker';
import configureStore, { history } from './store/configureStore';

import 'semantic-ui-css/semantic.min.css';
import 'react-datepicker/dist/react-datepicker.css';

import './styles/site.scss';

unregister();

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const store = configureStore();

ReactDOM.render(
	<BrowserRouter basename={baseUrl}>
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<Route path='/' render={props => <App {...props} />} />
			</ConnectedRouter>
		</Provider>
	</BrowserRouter>,
	rootElement
);
